import { useCallback, useState, useMemo, useEffect, useRef } from 'react';
import { getLimits } from "../../../../../lib/services/limits";
import { getImplementation } from "../../../../../lib/services/implementations";
import { ENTITIES } from "../../../../../lib/constants";
const LIMIT_ENTITIES_NAMES = {
  [ENTITIES.ACCOUNTS.importExport]: 'lim_max_accounts',
  [ENTITIES.CONTACTS.importExport]: 'lim_max_contacts',
  [ENTITIES.OPPORTUNITIES.importExport]: 'lim_max_opportunities'
};
const useAvoidDuplicates = _ref => {
  let {
    entityName,
    data,
    licenseEditionCode
  } = _ref;
  const isUsers = entityName === 'users';
  const [modalConfirmIsOpen, setModalConfirmIsOpen] = useState(false);
  const [modalLimitsIsOpen, setModalLimitsIsOpen] = useState(false);
  const [duplicatesForm, setDuplicatesForm] = useState({
    enabled: isUsers,
    type: 3
  });
  const [limits, setLimits] = useState(null);
  const [licenseCode, setLicenseCode] = useState(licenseEditionCode || '');
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender !== null && isFirstRender !== void 0 && isFirstRender.current) {
      isFirstRender.current = false;
      const implementationPromise = licenseCode ? Promise.resolve() : getImplementation();
      Promise.all([getLimits(), implementationPromise]).then(_ref2 => {
        var _implementation$data, _implementation$data2;
        let [responseLimits, implementation] = _ref2;
        const data = responseLimits.data || [];
        const newLimits = data.reduce((obj, current) => {
          if ((current === null || current === void 0 ? void 0 : current.itemCode) === LIMIT_ENTITIES_NAMES[entityName]) {
            obj = {
              limitUsed: (current === null || current === void 0 ? void 0 : current.limitUsed) || 0,
              limit: (current === null || current === void 0 ? void 0 : current.value) || 0
            };
          }
          return obj;
        }, {});
        setLimits(newLimits);
        if (licenseCode || !(implementation !== null && implementation !== void 0 && (_implementation$data = implementation.data) !== null && _implementation$data !== void 0 && _implementation$data.licenseEditionCode)) return;
        setLicenseCode(implementation === null || implementation === void 0 ? void 0 : (_implementation$data2 = implementation.data) === null || _implementation$data2 === void 0 ? void 0 : _implementation$data2.licenseEditionCode);
      });
    }
  }, [entityName, licenseCode]);
  const isOverLimits = useMemo(() => {
    const newRows = data.rows || 0;
    if (!newRows || !(limits !== null && limits !== void 0 && limits.limit)) return false;
    const existingRows = (limits === null || limits === void 0 ? void 0 : limits.limitUsed) || 0;
    const totalRows = newRows + existingRows;
    return totalRows > limits.limit;
  }, [data === null || data === void 0 ? void 0 : data.rows, limits]);
  const shouldConsiderLimits = useMemo(() => {
    if (data.importType !== 'create' || !['starter', 'essential'].includes(licenseCode)) return false;
    return true;
  }, [licenseCode, data.importType]);
  const onConfirmLimits = useCallback(() => {
    setModalLimitsIsOpen(false);
    setModalConfirmIsOpen(true);
  }, []);
  const onCancelLimits = useCallback(() => {
    setModalLimitsIsOpen(false);
  }, []);
  const onConfirm = useCallback(() => {
    if (isOverLimits && shouldConsiderLimits) {
      setModalLimitsIsOpen(true);
      return;
    }
    setModalConfirmIsOpen(true);
  }, [isOverLimits, shouldConsiderLimits]);
  const onCancelConfirm = useCallback(() => {
    setModalConfirmIsOpen(false);
  }, []);
  const showFields = duplicatesForm.enabled && !isUsers;
  const isConfirmDisabled = useMemo(() => {
    var _fields, _fields2;
    let fields = duplicatesForm.fields;
    if ((_fields = fields) !== null && _fields !== void 0 && _fields.length) fields = fields.filter(el => el !== null);
    return showFields && !((_fields2 = fields) !== null && _fields2 !== void 0 && _fields2.length);
  }, [duplicatesForm.fields, showFields]);
  return {
    avoidDuplicatesProps: {
      modalConfirmIsOpen,
      setModalConfirmIsOpen,
      duplicatesForm,
      setDuplicatesForm,
      onCancelConfirm,
      modalLimitsIsOpen,
      limits,
      onConfirmLimits,
      onCancelLimits
    },
    avoidDuplicatesFooterProps: {
      onConfirm,
      isConfirmDisabled: isConfirmDisabled
    }
  };
};
export default useAvoidDuplicates;